import { DatePicker, type DatePickerSlotProps } from '@mui/x-date-pickers';
import { DATE_FORMAT, formatDate } from '@src/shared/lib';
import { useState } from 'react';
import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import { CalendarTodayIcon } from '@src/shared/ui/icons';

type DatePickerInputProps = ComponentPropsWithoutRef<typeof DatePicker> & {
  required?: boolean;
  fullWidth?: boolean;
  helperText?: ReactNode;
  error?: boolean;
  slotProps?: DatePickerSlotProps<boolean>;
  onOpen?: (...args: unknown[]) => void;
  onClose?: (...args: unknown[]) => void;
};

function DatePickerInput(props: DatePickerInputProps) {
  const [open, setOpen] = useState(false);
  const {
    error,
    fullWidth,
    helperText,
    required,
    slotProps = {},
    slots = {},
    onClose,
    onOpen,
    ...rest
  } = props;

  const textFieldSlotProps = (slotProps.textField ?? {}) as Record<string, unknown>;
  const inputProps = (textFieldSlotProps.InputProps ?? {}) as Record<string, unknown>;
  const textFieldOnClick = textFieldSlotProps.onClick as ((event: unknown) => void) | undefined;

  return (
    <DatePicker
      {...rest}
      format={DATE_FORMAT}
      open={open}
      dayOfWeekFormatter={(day) =>
        formatDate(day, { weekday: 'long' }).slice(0, 2)
      }
      onOpen={(...args: unknown[]) => {
        setOpen(true);
        (onOpen as ((...cbArgs: unknown[]) => void) | undefined)?.(...args);
      }}
      onClose={(...args: unknown[]) => {
        setOpen(false);
        (onClose as ((...cbArgs: unknown[]) => void) | undefined)?.(...args);
      }}
      slots={{
        ...(slots as Record<string, unknown>),
        openPickerButton: () => null,
      }}
      slotProps={{
        ...slotProps,
        textField: {
          required,
          fullWidth,
          helperText,
          error,
          ...textFieldSlotProps,
          InputProps: {
            startAdornment: <CalendarTodayIcon />,
            ...inputProps,
          },
          onClick: (event: unknown) => {
            setOpen(true);
            textFieldOnClick?.(event);
          },
        },
      }}
    />
  );
}

export default DatePickerInput;
